/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import { qreq } from "../../shared/qrequest";
import L from "../Lang"
import BaseCom from "../BaseCom";
import DataTable from "../DataTable";
import { SidebarGlobal } from "../_Sidebar";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Icon from "../Icon";
import { Pop } from "../PopModal";
import Globals from "../../shared/Globals";

class SurveyAdmin extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        };
    }

    componentDidMount() {
        SidebarGlobal.setSubNav(<div className="btn-group">
            <Link to="/survey/new" className="btn btn-primary"><Icon icon="faPlus" /> <span className="d-none d-md-inline"><L>New Survey</L></span></Link>
        </div>);
        qreq.get('/api/survey/config', j => {
            if (j.item) {
                this.setState({ config: j.item });
                qreq.get('/api/survey/list', j => {
                    if (j.list) {
                        Globals.processResultObject(j);
                        this.setState({ list: j.list, loaded: true });
                    }
                    else
                        this.alert(j.errorMessage);
                }, this.unkownErrorCallback);
            }
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    render() {
        return <div className="container-fluid">
            <h1><L>Surveys</L></h1>
            <DataTable columns={[
                { linkTitle: 'Edit Survey', icon: 'Pencil', link: '/survey/edit/:id' },
                {
                    linkTitle: 'View Survey', icon: 'Eye', onClick: row => {
                        if (row.published) {
                            if (row.ident)
                                window.open(this.state.config.surveyUrl + '/f/' + row.ident);
                            else
                                window.open(this.state.config.surveyUrl + '/fill/' + row.masterID);
                        }
                        else
                            Pop.show('This survey is not yet published.', 'Not Published');
                    }
                },
                { linkTitle: 'View Submissions', icon: 'List', link: '/survey/:id/submission' },
                { name: 'name', title: 'Survey', link: '/survey/:id/submission' },
                {
                    name: 'currentRevision', title: 'Editing Revision', valueFunc: row => {
                        return row.currentRevision;
                    }
                },
                {
                    name: 'published', title: 'Published', valueFunc: row => {
                        if (row.published)
                            return 'True';
                        else
                            return 'False';
                    }
                },
                {
                    name: 'publishedRevision', title: 'Published Revision', valueFunc: row => {
                        if (row.published)
                            return row.publishedRevision;
                        return 'None';
                    }
                },
                { name: 'createdDate', title: 'Created' }
            ]} data={this.state.list} totalCount={this.state.totalCount} loading={!this.state.loaded} />
        </div>;
    }
}

export default withParamsAndNavigate(SurveyAdmin);